import { NSARouterMakerResult } from "namirasoft-account-react";
import { InteractionRow } from "namirasoft-inference";
import { NSLoading, NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
import { Component } from "react";
import { useParams } from "react-router-dom";
import Interaction from "../components/Interaction";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface InteractionViewPageInnerProps extends NSARouterMakerResult, InferenceRouterProps
{
    interaction_id: string;
}

interface InteractionViewPageInnerState
{
    interaction: InteractionRow | null;
}

class InteractionViewPageInner extends Component<InteractionViewPageInnerProps, InteractionViewPageInnerState>
{
    override state: InteractionViewPageInnerState = { interaction: null };

    override componentDidMount(): void { this.load(); }

    override componentDidUpdate(prev: InteractionViewPageInnerProps): void
    {
        if (prev.interaction_id !== this.props.interaction_id)
            this.load();
    }

    private async load(): Promise<void>
    {
        let id = this.props.interaction_id;
        if (!id) { this.setState({ interaction: null }); return; }
        try
        {
            let row = await this.props.servers.inference.interaction.Get(id);
            this.setState({ interaction: row });
        }
        catch (e) { console.error(e); }
    }

    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.interaction_view }}
                pages={{
                    entity: InferenceEntities.interaction(this.props),
                    view: {}
                }}
            >
                <>
                    <NSSpace size={NSSpaceSizeType.SMALL} />
                    {
                        this.state.interaction ?
                            <Interaction interaction={this.state.interaction} /> :
                            <NSLoading title="Loading interaction ..." />
                    }
                </>
            </InferenceLayout>
        );
    }
}

interface InteractionViewPageProps extends NSARouterMakerResult, InferenceRouterProps { }

function InteractionViewPage(props: InteractionViewPageProps)
{
    let params = useParams();
    let interaction_id = params["id"] ?? "";
    return <InteractionViewPageInner {...props} interaction_id={interaction_id} />;
}

export default InteractionViewPage;